const STORAGE_KEY = 'mesendger_device_id';

function randomHex() {
  const a = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(a);
  } else {
    for (let i = 0; i < a.length; i++) a[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Стабильный идентификатор устройства для доверенных сессий и refresh (сервер обрезает до 128 символов). */
export function getOrCreateDeviceId() {
  if (typeof window === 'undefined') return '';
  try {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
      id = randomHex();
      localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
  } catch {
    return randomHex();
  }
}
